import { render, staticRenderFns } from "./AssistRequestContent.vue?vue&type=template&id=0eebd956&scoped=true"
import script from "./AssistRequestContent.vue?vue&type=script&lang=ts"
export * from "./AssistRequestContent.vue?vue&type=script&lang=ts"
import style0 from "./AssistRequestContent.vue?vue&type=style&index=0&id=0eebd956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eebd956",
  null
  
)

export default component.exports